var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3876 14.6667H16.3342L15.9609 14.3067C17.2676 12.7867 18.0542 10.8133 18.0542 8.66667C18.0542 3.88 14.1742 0 9.38755 0C4.60089 0 0.720886 3.88 0.720886 8.66667C0.720886 13.4533 4.60089 17.3333 9.38755 17.3333C11.5342 17.3333 13.5076 16.5467 15.0275 15.24L15.3876 15.6133V16.6667L22.0542 23.32L24.0409 21.3333L17.3876 14.6667ZM9.38755 14.6667C6.06755 14.6667 3.38755 11.9867 3.38755 8.66667C3.38755 5.34667 6.06755 2.66667 9.38755 2.66667C12.7076 2.66667 15.3876 5.34667 15.3876 8.66667C15.3876 11.9867 12.7076 14.6667 9.38755 14.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.97ac88bf.svg";
export { ForwardRef as ReactComponent };